import { Member } from './viewModel'

export const mapMemberModelToVM = (member): Member => ({
  name: member.node.name,
  role: member.node.role,
  description: member.node.description.childMarkdownRemark.html,
  imageFluid: member.node.image.fluid,
})
